"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadGrouped = exports.LOAD_GROUPED_EMPTY = exports.LOAD_GROUPED_FAILURE = exports.LOAD_GROUPED_SUCCESS = exports.LOAD_GROUPED_REQUEST = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _index = require("../../../../index");

var _helpers = require("../../../helpers");

var _middleware = require("../../../middleware");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var LOAD_GROUPED_REQUEST = 'LOAD_GROUPED_REQUEST';
exports.LOAD_GROUPED_REQUEST = LOAD_GROUPED_REQUEST;
var LOAD_GROUPED_SUCCESS = 'LOAD_GROUPED_SUCCESS';
exports.LOAD_GROUPED_SUCCESS = LOAD_GROUPED_SUCCESS;
var LOAD_GROUPED_FAILURE = 'LOAD_GROUPED_FAILURE';
exports.LOAD_GROUPED_FAILURE = LOAD_GROUPED_FAILURE;
var LOAD_GROUPED_EMPTY = 'LOAD_GROUPED_EMPTY';
exports.LOAD_GROUPED_EMPTY = LOAD_GROUPED_EMPTY;

var loadGroupedRequest = function loadGroupedRequest() {
  return {
    type: LOAD_GROUPED_REQUEST
  };
};

var loadGroupedSuccess = function loadGroupedSuccess(characteristics) {
  return {
    type: LOAD_GROUPED_SUCCESS,
    payload: characteristics
  };
};

var loadGroupedFailure = function loadGroupedFailure(error) {
  return {
    type: LOAD_GROUPED_FAILURE,
    error: error
  };
};

var loadGroupedEmpty = function loadGroupedEmpty() {
  return {
    type: LOAD_GROUPED_EMPTY
  };
};

var loadGrouped = function loadGrouped() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var currentState, characteristics, answerIds, audienceView, tagId, isDataPage, currentUniverse, customHeaders, viewSlug, token, baseUrl, response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              currentState = getState();
              characteristics = currentState.selectedCharacteristics.characteristics;
              answerIds = characteristics.map(function (characteristic) {
                return characteristic.answerId;
              }).join(',');
              audienceView = currentState.audienceView.view.segmentType;
              tagId = currentState.options.tagIds.findPersonasGrouped;
              isDataPage = currentState.options.isDataPage.value;

              if (!(answerIds.length <= 0)) {
                _context.next = 10;
                break;
              }

              dispatch(loadGroupedEmpty());
              return _context.abrupt("return", {});

            case 10:
              (0, _index.refreshToken)(dispatch);
              dispatch(loadGroupedRequest());
              currentUniverse = currentState.universes.currentUniverse;
              customHeaders = {
                'context-organisation': currentState.auth.organisations.currentOrganisation,
                'context-team': currentState.auth.teams.currentTeam
              };

              if (isDataPage) {
                viewSlug = audienceView;
              } else {
                viewSlug = 'segments';
              }

              token = (0, _index.getAuthToken)();
              baseUrl = (0, _helpers.productEndpoint)();
              _context.next = 19;
              return (0, _middleware.callAPIv2)({
                method: 'GET',
                targetUrl: baseUrl + "/campaign-creator/grouped/" + viewSlug + "?answerIds=" + answerIds + "&universeId=" + currentUniverse + "&tagId=" + tagId,
                token: token,
                headers: customHeaders
              });

            case 19:
              response = _context.sent;

              if (!(response instanceof Error)) {
                _context.next = 22;
                break;
              }

              return _context.abrupt("return", response);

            case 22:
              dispatch(loadGroupedSuccess(response));
              _context.next = 30;
              break;

            case 25:
              _context.prev = 25;
              _context.t0 = _context["catch"](0);
              dispatch(loadGroupedFailure(_context.t0.message));

              if (process.env.NODE_ENV !== 'test') {
                Sentry.captureException(_context.t0);
                console.error(_context.t0);
              }

              return _context.abrupt("return", _context.t0);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 25]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.loadGrouped = loadGrouped;